// import React, { useEffect, useState } from 'react'
// import { useDispatch, useSelector } from 'react-redux'
// import { useFormik } from 'formik'
// import CustomSelect from '../../components/CustomSelectInput'
// import CustomButton from '../../components/CustomButton'
// import useCustomStyles from '../../hooks/useCustomStyles'
// import { customStyles } from '../../assets/styles/notificationForm'
// import { selectTranslationState } from '../../store/slices/languageSlice'
// import { selectState } from '../../store/slices/themeSlice'
// import CustomInput from '../../components/CustomInput'
// import { AppDispatch, RootState } from '../../store/store'
// import {
//   AccessCodeType,
//   addAccessCode,
//   addReferralCode,
//   ContractType,
//   getBusinesses,
//   getContractsByBusinesses,
// } from '../../store/actions/accessCodeActions'
// import CustomMultiSelect from '../../components/CustomMultiSelect'
// import validationSchema from './scripts'
// import { Option } from '../../components/CustomMultiSelect'
// import {
//   listenToLicenceCountUpdates,
//   listenToLicenceValidatedUpdates,
// } from '../../db/listners'
// import { setContracts, setLicence } from '../../store/slices/accessCodeSlice'
// import { useNavigate } from 'react-router-dom'

// const GenerateAccessCode = () => {
//   const { t } = useSelector(selectTranslationState)
//   const { theme, activeTheme , textTheme} = useSelector(selectState)
//   const { businesses, contracts, loading } = useSelector(
//     (state: RootState) => state.accessCode_slice,
//   )
//   const classes = useCustomStyles(customStyles, theme)
//   const [filteredContracts, setFilteredContracts] = useState(contracts)
//   const [openLicenceCount, setOpenLicenceCount] = useState(0)
//   const dispatch = useDispatch<AppDispatch>()
//   const { user } = useSelector((state: RootState) => state.auth_slice)

//   useEffect(() => {
//     // Define the function that updates the state (or dispatches a Redux action)
//     const handleLicenseUpdate = (accessCode: AccessCodeType) => {
//       // Example of dispatching a Redux action
//       dispatch(setLicence(accessCode))
//     }

//     const updateContractsInState = (contracts: ContractType[]) => {
//       // Dispatch an action to update the entire contracts list in the Redux store
//       dispatch(setContracts(contracts)) // Ensure this action is set up in your Redux slice
//     }
//     // Start listening to licence validated updates
//     const unsubscribeLicence = listenToLicenceValidatedUpdates(
//       handleLicenseUpdate,
//     )

//     // Start listening to licence count updates
//     const unsubscribeContract = listenToLicenceCountUpdates(
//       updateContractsInState,
//     )

//     // Cleanup listener when the component unmounts
//     return () => {
//       if (unsubscribeLicence) {
//         unsubscribeLicence() // Unsubscribe from licence updates
//       }
//       if (unsubscribeContract) {
//         unsubscribeContract() // Unsubscribe from contract updates
//       }
//     }
//   }, [])

//   const navigate = useNavigate()

//   const roleList = [
//     // {label: 'Marketing', value: 'Marketing'},
//     { label: 'CRM', value: 'CRM' },
//     { label: 'Administrator', value: 'Administrator' },
//   ]

//   const initialValues = {
//     roles: [],
//     role_type: 'client',
//     codeType: '',
//     contract_ref: '',
//     contract_left_licences: 0,
//     business_client: '',
//     for_business_client: 'elisyan',
//     prefix: undefined,
//     partner: '',
//     email: '',
//     expire_at: '',
//     useLimit: 1,
//     free_duration: undefined,
//     number_of_codes_to_generate: 1,
//   }

//   const formik = useFormik({
//     initialValues: initialValues,
//     validationSchema: validationSchema,
//     onSubmit: async (values) => {
//       if (values.codeType == 'licence-code') {
//         await dispatch(
//           addAccessCode({
//             role_type: values.role_type,
//             roles: values.roles,
//             expire_at:
//               values.codeType == 'licence-code'
//                 ? filteredContracts
//                     ?.filter((item) => item.id == values.contract_ref)[0]
//                     .expire_at?.toString()
//                 : values.expire_at,
//             codeType: values.codeType,
//             contract_ref: values.contract_ref,
//             business_client: values.business_client,
//             number_of_codes_to_generate: values.number_of_codes_to_generate,
//             navigate,
//           }),
//         )
//       } else {
//         await dispatch(
//           addReferralCode({
//             expire_at: values.expire_at,
//             business_client: values.business_client,
//             for_business_client: values.for_business_client,
//             prefix: values.prefix,
//             number_of_codes_to_generate: values.number_of_codes_to_generate,
//             useLimit: values.useLimit || 1,
//             free_duration: values.free_duration
//               ? parseInt(values.free_duration)
//               : undefined,
//             navigate,
//           }),
//         )
//       }
//     },
//     validateOnChange: false, // Disable validation on change
//     validateOnBlur: false, // Disable validation on blur
//   })

//   const {
//     values,
//     setFieldValue,
//     handleBlur,
//     handleSubmit,
//     setFieldTouched,
//   } = formik

//   const handleGetBusinesses = () => {
//     dispatch(getBusinesses({ type: '' }))
//   }

//   useEffect(() => {
//     if (formik.values.codeType) {
//       formik.resetForm({
//         values: { ...initialValues, codeType: formik.values.codeType },
//       })
//     }
//   }, [formik.values.codeType])

//   useEffect(() => {
//     if (user && user.business) {
//       if (user?.business?.name) {
//         const isAdmin = user.roles.includes('master')
//         let businessNames: string[]

//         switch (user.business.name) {
//           case 'sopher':
//             businessNames = isAdmin
//               ? ['sopher', 'SOPHER_ACCOUNTING']
//               : ['sopher']
//             break

//           case 'sopher-test': {
//             // console.log('sopher-test business name from get clients',user.email, user.user_name ,user.business.name)
//             businessNames = isAdmin
//               ? ['sopher-test', 'SOPHER_ACCOUNTING_TEST']
//               : ['sopher-test']
//             break
//           }

//           default: {
//             //  console.log('default business name from get clients',user.email, user.user_name ,user.business.name)
//             businessNames = [user.business.name]
//             break
//           }
//         }
//         dispatch(getContractsByBusinesses({ business_names: businessNames }))
//       }
//     }

//     handleGetBusinesses()
//   }, [])

//   useEffect(() => {
//     // console.log(' fetch contracts for business', formik.values.business_client)
//     if (
//       formik.values.business_client &&
//       typeof formik.values.business_client == 'string' &&
//       formik.values.business_client.length > 0 &&
//       contracts &&
//       contracts.length > 0
//     ) {
//       // setFilteredContracts(contracts.filter((item: ContractType )=> item.business_client == formik.values.business_client));
//       setFilteredContracts(
//         contracts.filter(
//           (item: ContractType) =>
//             item.business_client == formik.values.business_client &&
//             item.useLimit - item.licence_count > 0 &&
//             item.expire_at &&
//             new Date(item.expire_at) > new Date(),
//         ),
//       )
//     }
//   }, [formik.values.business_client])

//   // Wrapper function to handle form submission from button click
//   const handleFormSubmit = async (
//     event: React.MouseEvent<HTMLButtonElement>,
//   ) => {
//     event.preventDefault()
//     await formik.submitForm()

//     /* const isValid = await formik.validateForm(); // Validate the form
//     formik.setTouched();
//     // Check if there are errors in the form
//     if (Object.keys(isValid).length === 0) {
//       try {
//         await formik.submitForm(); // Call the Formik's submit function, which should handle your API call
//         // If successful, reset the form
//         formik.resetForm();
//       } catch (e) {
//         console.log('Error while submitting the form:', e);
//         // Handle error, e.g., show an error message to the user
//       }
//     } else {
//       console.log('Form has errors:', isValid);
//       // You may want to display these errors to the user
//     }*/
//   }

//   const handleContractRefChange = async (
//     e: React.ChangeEvent<HTMLSelectElement>,
//   ) => {
//     const { name, value } = e.target
//     await setFieldValue(name, value)
//     await setFieldTouched(name, true)
//     const valid = await validationSchema.validateAt(name, { [name]: value })
//     if (valid) {
//       formik.setFieldError(name, undefined) // Clear the error if validation passes
//       const selectedContract = filteredContracts?.filter(
//         (item) => item.id == e.target.value,
//       )
//       if (selectedContract && selectedContract?.length > 0) {
//         setOpenLicenceCount(
//           selectedContract[0].useLimit - selectedContract[0].licence_count,
//         )
//         setFieldValue('expire_at', selectedContract[0].expire_at)
//         setFieldValue('business_client', selectedContract[0].business_client)
//         setFieldValue(
//           'contract_left_licences',
//           selectedContract[0].useLimit - selectedContract[0].licence_count,
//         )
//         const validCount = await validationSchema.validateAt(
//           'contract_left_licences',
//           {
//             ['contract_left_licences']:
//               selectedContract[0].useLimit - selectedContract[0].licence_count,
//           },
//         )
//         if (validCount) {
//           formik.setFieldError('contract_left_licences', undefined) // Clear the error if validation passes
//         } else {
//           formik.setFieldError(
//             'contract_left_licences',
//             'All licences in the selected contract have been used. Please choose another contract.',
//           )
//         }

//         try {
//           await validationSchema.validateAt('expire_at', {
//             expire_at: selectedContract[0].expire_at
//               ? new Date(selectedContract[0].expire_at)
//               : '',
//             codeType: ['licence-code'], // include this as well
//           })
//           formik.setFieldError('expire_at', undefined)
//         } catch (error) {
//           if (error instanceof Error) {
//             // Handle the error if validation fails
//             console.error('Validation error:', error.message)
//           }
//           formik.setFieldError(
//             'expire_at',
//             'The selected contract has expired. Please choose another contract.',
//           )
//         }
//       }
//     }
//   }

//   const handleSelectFieldChange1 = async (
//     e:
//       | React.ChangeEvent<HTMLSelectElement>
//       | React.ChangeEvent<HTMLInputElement>,
//   ) => {
//     const { name, value } = e.target

//     if (name == 'business_client') {
//       await setFieldValue('contract_ref', '')
//       setOpenLicenceCount(0)
//       setFieldValue('contract_left_licences', 0)
//     }
//     await setFieldValue(name, value)
//     await setFieldTouched(name, true)
//     if (name == 'role_type' && value == 'client') {
//       await setFieldValue('roles', [])
//     }

//     if (name == 'codeType' && value == 'referral-code') {
//       setFieldValue(
//         'business_client',
//         businesses?.find((item) => item.name == 'elisyan')?.id || '',
//       )
//     }

//     const valid = await formik.validateForm()
//     if (valid) {
//       // console.log('field validated', name, value)
//     } else {
//       // console.log('field not validated', name, formik.errors)
//     }
//   }

//   const handleSelectFieldChange2 = async (e: {
//     name: string
//     value: string | number | Option[]
//   }) => {
//     const { name, value } = e
//     await setFieldValue(name, value)
//     await setFieldTouched(name, true)
//     const valid = await formik.validateForm()
//     if (valid) {
//       // console.log('field validated', name, value)
//     } else {
//       // console.log('field not validated', name, formik.errors)
//     }
//   }

//   console.log('formik errors', formik.errors)
//   useEffect(() => {
//     // Log the form errors whenever they change
//     console.log(
//       'Current form errors:',
//       formik.errors,
//       formik.values,
//       formik.dirty,
//       formik.isValid,
//     )
//   }, [formik.errors, formik.values])

//   return (
//     <div className={classes?.container}>
//       <div className={classes?.notificationForm}>
//         <h1 className={classes?.title}>
//           {t[textTheme].referralCodeScreen.form.title}
//         </h1>
//         <hr className={classes?.divider} />

//         <form onSubmit={handleSubmit} className={classes?.notificationForm}>
//           <CustomSelect
//             name="codeType"
//             value={values.codeType}
//             options={['licence-code', 'referral-code', 'invite-code']}
//             onChange={(e) => handleSelectFieldChange1(e)}
//             onBlure={handleBlur}
//             placeholder="Select Code Type"
//             label="Code Type"
//           />

//           {/* {values.codeType === 'invite-code' && (
//             <SearchableSelect
//               options={emailList}
//               value={values.email}
//               onChange={(value: string) => setFieldValue('email', value)}
//               placeholder="Search for an email..."
//             />
//           )} */}

//           {values.codeType === 'licence-code' && (
//             <>
//               <CustomSelect
//                 label="Business Client"
//                 name="business_client"
//                 value={values.business_client}
//                 options={
//                   businesses
//                     ? businesses.map((item) => ({
//                         name: item.name,
//                         id: item.id,
//                       }))
//                     : []
//                 }
//                 onChange={async (e) => await handleSelectFieldChange1(e)}
//                 placeholder="Select Business Client"
//                 onBlure={handleBlur}
//                 error={
//                   formik.errors.business_client &&
//                   formik.touched.business_client
//                     ? formik.errors.business_client
//                     : ''
//                 }
//               />

//               {values.business_client && (
//                 <>
//                   <CustomSelect
//                     label="Contract Reference"
//                     name="contract_ref"
//                     value={values.contract_ref}
//                     options={
//                       filteredContracts
//                         ? filteredContracts
//                             .filter((item) => item.contract_ref && item.id) // Ensures both are defined
//                             .map((item) => ({
//                               name: item.contract_ref as string,
//                               id: item.id as string,
//                             })) // Explicitly cast to string
//                         : []
//                     }
//                     onChange={async (e) => await handleContractRefChange(e)}
//                     onBlure={handleBlur}
//                     placeholder="Select Contract Referrence"
//                     error={
//                       formik.errors.contract_ref && formik.touched.contract_ref
//                         ? formik.errors.contract_ref
//                         : ''
//                     }
//                   />
//                   {values.contract_ref && (
//                     <>
//                       {' '}
//                       <CustomInput
//                         label={`Remaining Licences in the selected contract`}
//                         name="contract_left_licences"
//                         type="number"
//                         value={openLicenceCount}
//                         onChange={async (e) =>
//                           await handleSelectFieldChange1(e)
//                         }
//                         disabled={true}
//                       />
//                       <CustomInput
//                         label={
//                           t[textTheme].generateLicencesScreen.form
//                             .subscriptionExpiryInput.label
//                         }
//                         name="expire_at"
//                         type="text"
//                         value={values.expire_at}
//                         onChange={() => {
//                           return
//                         }}
//                         disabled
//                         error={
//                           formik.errors.expire_at ? formik.errors.expire_at : ''
//                         }
//                       />
//                       <CustomSelect
//                         label="Role Type"
//                         name="role_type"
//                         value={values.role_type}
//                         options={[
//                           { name: 'Client', id: 'client' },
//                           { name: 'Advisor', id: 'advisor' },
//                         ]}
//                         onChange={async (e) =>
//                           await handleSelectFieldChange1(e)
//                         }
//                         placeholder="Select Business Client"
//                         onBlure={handleBlur}
//                         error={
//                           formik.errors.role_type && formik.touched.role_type
//                             ? formik.errors.role_type
//                             : ''
//                         }
//                       />
//                       {values.role_type == 'advisor' && (
//                         <CustomMultiSelect
//                           name="roles"
//                           value={values.roles}
//                           onChange={(value) =>
//                             handleSelectFieldChange2({
//                               name: 'roles',
//                               value: value,
//                             })
//                           }
//                           options={roleList}
//                           label="Roles To Assign"
//                           error={
//                             Array.isArray(formik.errors.roles)
//                               ? formik.errors.roles.join(', ') // Combine all error messages into a single string
//                               : formik.errors.roles || ''
//                           }
//                         />
//                       )}
//                       <CustomInput
//                         label="Number of Licences to generate"
//                         name="number_of_codes_to_generate"
//                         type="number"
//                         min={1}
//                         max={values.contract_left_licences}
//                         value={values.number_of_codes_to_generate}
//                         onChange={async (e) =>
//                           await handleSelectFieldChange1(e)
//                         }
//                         onBlure={handleBlur}
//                         placeholder="Number of licences to generate"
//                         error={
//                           formik.errors.number_of_codes_to_generate &&
//                           formik.touched.number_of_codes_to_generate
//                             ? formik.errors.number_of_codes_to_generate
//                             : ''
//                         }
//                       />
//                     </>
//                   )}
//                 </>
//               )}
//             </>
//           )}

//           {values.codeType === 'referral-code' && (
//             <>
//               {/* <CustomSelect
//                 name="business_client"
//                 value={values.business_client}
//                 options={
//                   businesses
//                     ? businesses.filter((item) => item.type !== 'distributer').map((item) => ({
//                         name: item.name,
//                         id: item.id,
//                       }))
//                     : []
//                 }
//                 onChange={(e) => handleSelectFieldChange1(e)}
//                 placeholder="Select Business Client Owner Of This Code"
//                 label="Business Client"
//                 disabled={false}
//                 error={
//                   formik.errors.business_client &&
//                   formik.touched.business_client
//                     ? formik.errors.business_client
//                     : ''
//                 }
//               />
//               <CustomSelect
//                 name="for_business_client"
//                 value={values.for_business_client}
//                 options={
//                   businesses
//                     ? businesses.map((item) => ({
//                         name: item.name,
//                         id: item.name,
//                       }))
//                     : []
//                 }
//                 onChange={(e) => handleSelectFieldChange1(e)}
//                 placeholder="Select Business Client That Will Share This Code"
//                 label="Business Client That will share the code"
//                 error={
//                   formik.errors.for_business_client &&
//                   formik.touched.for_business_client
//                     ? formik.errors.for_business_client
//                     : ''
//                 }
//               /> */}
//                <CustomSelect
//       name="business_client"
//       value={values.business_client}
//       options={
//         businesses
//           ? businesses
//               .filter((item) => item.type !== 'distributer')
//               .map((item) => ({ name: item.name, id: item.id }))
//           : []
//       }
//       onChange={(e) => {
//         handleSelectFieldChange1(e);

//         const selectedBusiness = businesses?.find(
//           (item) => item.id === e.target.value
//         );

//         if (selectedBusiness && selectedBusiness.name !== 'elisyan') {
//           // Mirror the value into for_business_client
//           formik.setFieldValue('for_business_client', selectedBusiness.name);
//         } else {
//           // Reset it when business_client is elisyan (or cleared)
//           formik.setFieldValue('for_business_client', '');
//         }
//       }}
//       placeholder="Select Business Client Owner Of This Code"
//       label="Business Client"
//       disabled={false}
//       error={
//         formik.errors.business_client && formik.touched.business_client
//           ? formik.errors.business_client
//           : ''
//       }
//     />

//     <CustomSelect
//       name="for_business_client"
//       value={values.for_business_client}
//       options={
//         businesses
//           ? businesses.map((item) => ({ name: item.name, id: item.name }))
//           : []
//       }
//       onChange={(e) => handleSelectFieldChange1(e)}
//       placeholder="Select Business Client That Will Share This Code"
//       label="Business Client That will share the code"
//       disabled={
//         businesses?.find((item) => item.id === values.business_client)
//           ?.name !== 'elisyan' && !!values.business_client
//       }
//       error={
//         formik.errors.for_business_client && formik.touched.for_business_client
//           ? formik.errors.for_business_client
//           : ''
//       }
//     />
//               <CustomInput
//                 label="Prefix"
//                 name="prefix"
//                 type="text"
//                 value={values.prefix}
//                 onChange={(e) => handleSelectFieldChange1(e)}
//                 placeholder="Enter a Prefix"
//                 error={
//                   formik.errors.prefix && formik.touched.prefix
//                     ? formik.errors.prefix
//                     : ''
//                 }
//               />
//               <CustomInput
//                 label="Expiry Date"
//                 name="expire_at"
//                 type="date"
//                 value={values.expire_at}
//                 onChange={(e) => handleSelectFieldChange1(e)}
//                 placeholder="Select Expiry date"
//                 error={
//                   formik.errors.expire_at && formik.touched.expire_at
//                     ? formik.errors.expire_at
//                     : ''
//                 }
//               />
//               <CustomSelect
//                 name="free_duration"
//                 label="Free Trial Duration"
//                 value={values.free_duration || ''}
//                 onChange={handleSelectFieldChange1}
//                 placeholder="-- Select Duration --"
//                 options={[
//                   { id: '1', name: '1 Day' },
//                   { id: '7', name: '1 Week' },
//                   { id: '15', name: '2 Weeks' },
//                   { id: '30', name: '1 Month' },
//                   { id: '90', name: '3 Months' },
//                   { id: '180', name: '6 Months' },
//                   { id: '365', name: '1 Year' },
//                 ]}
//               />
//               {/*<CustomInput
//                 label='number of codes to generate'
//                 name="number_of_codes_to_generate"
//                 type="number"
//                 value={values.number_of_codes_to_generate}
//                 onChange={handleChange}
//                 placeholder="Number of referral codes to generate"
//                 error= {(formik.errors.number_of_codes_to_generate && formik.touched.number_of_codes_to_generate) ?
//                   formik.errors.number_of_codes_to_generate : ''}
//               />*/}
//               <CustomInput
//                 label="Use Limit"
//                 name="useLimit"
//                 type="number"
//                 value={values.useLimit}
//                 onChange={(e) => handleSelectFieldChange1(e)}
//                 placeholder="Maximum number of users to use this access code"
//                 error={
//                   formik.errors.useLimit && formik.touched.useLimit
//                     ? formik.errors.useLimit
//                     : ''
//                 }
//               />
//             </>
//           )}
//           {values.codeType && (
//             <CustomButton
//               title={
//                 values.codeType === 'licence-code'
//                   ? 'Generate Licences'
//                   : values.codeType === 'referral-code'
//                   ? 'Generate Referral Code'
//                   : 'Generate Invite Code'
//               }
//               name="generateAccessCode"
//               handleClick={handleFormSubmit}
//               type="submit"
//               loading={loading}
//               disabled={!formik.isValid || loading || !formik.dirty}
//             />
//           )}
//         </form>
//       </div>
//     </div>
//   )
// }

// export default GenerateAccessCode

























import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'
import CustomSelect from '../../components/CustomSelectInput'
import CustomButton from '../../components/CustomButton'
import useCustomStyles from '../../hooks/useCustomStyles'
import { customStyles } from '../../assets/styles/notificationForm'
import { selectTranslationState } from '../../store/slices/languageSlice'
import { selectState } from '../../store/slices/themeSlice'
import CustomInput from '../../components/CustomInput'
import { AppDispatch, RootState } from '../../store/store'
import {
  AccessCodeType,
  addAccessCode,
  addReferralCode,
  // TODO: implement this thunk in accessCodeActions, mirroring addReferralCode's
  // shape, but posting to a new Cloud Function that expects contract_ref and
  // validates useLimit against the contract's remaining licences.
  addWhitelabelReferralCode,
  ContractType,
  getBusinesses,
  getContractsByBusinesses,
} from '../../store/actions/accessCodeActions'
import CustomMultiSelect from '../../components/CustomMultiSelect'
import validationSchema from './scripts'
import { Option } from '../../components/CustomMultiSelect'
// import {
//   listenToLicenceCountUpdates,
//   listenToLicenceValidatedUpdates,
// } from '../../db/listners'
import { setContracts, setLicence } from '../../store/slices/accessCodeSlice'
import { useNavigate } from 'react-router-dom'

const GenerateAccessCode = () => {
  const { t } = useSelector(selectTranslationState)
  const { theme, activeTheme, textTheme } = useSelector(selectState)
  const { businesses, contracts, loading } = useSelector(
    (state: RootState) => state.accessCode_slice,
  )
  const classes = useCustomStyles(customStyles, theme)
  const [filteredContracts, setFilteredContracts] = useState(contracts)
  const [openLicenceCount, setOpenLicenceCount] = useState(0)
  const dispatch = useDispatch<AppDispatch>()
  const { user } = useSelector((state: RootState) => state.auth_slice)

  // useEffect(() => {
  //   // Define the function that updates the state (or dispatches a Redux action)
  //   const handleLicenseUpdate = (accessCode: AccessCodeType) => {
  //     // Example of dispatching a Redux action
  //     dispatch(setLicence(accessCode))
  //   }

  //   const updateContractsInState = (contracts: ContractType[]) => {
  //     // Dispatch an action to update the entire contracts list in the Redux store
  //     dispatch(setContracts(contracts)) // Ensure this action is set up in your Redux slice
  //   }
  //   // Start listening to licence validated updates
  //   const unsubscribeLicence = listenToLicenceValidatedUpdates(
  //     handleLicenseUpdate,
  //   )

  //   // Start listening to licence count updates
  //   const unsubscribeContract = listenToLicenceCountUpdates(
  //     updateContractsInState,
  //   )

  //   // Cleanup listener when the component unmounts
  //   return () => {
  //     if (unsubscribeLicence) {
  //       unsubscribeLicence() // Unsubscribe from licence updates
  //     }
  //     if (unsubscribeContract) {
  //       unsubscribeContract() // Unsubscribe from contract updates
  //     }
  //   }
  // }, [])

  const navigate = useNavigate()

  const roleList = [
    // {label: 'Marketing', value: 'Marketing'},
    { label: 'CRM', value: 'CRM' },
    { label: 'Administrator', value: 'Administrator' },
  ]

  const initialValues = {
    roles: [],
    role_type: 'client',
    codeType: '',
    contract_ref: '',
    contract_left_licences: 0,
    business_client: '',
    for_business_client: 'elisyan',
    prefix: undefined,
    partner: '',
    email: '',
    expire_at: '',
    useLimit: 1,
    free_duration: undefined,
    free_access_end_date: '', // NEW — computed from the linked contract's expire_at (whitelabel-referral-code only)
    number_of_codes_to_generate: 1,
  }

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      if (values.codeType == 'licence-code') {
        await dispatch(
          addAccessCode({
            role_type: values.role_type,
            roles: values.roles,
            expire_at:
              values.codeType == 'licence-code'
                ? filteredContracts
                    ?.filter((item) => item.id == values.contract_ref)[0]
                    .expire_at?.toString()
                : values.expire_at,
            codeType: values.codeType,
            contract_ref: values.contract_ref,
            business_client: values.business_client,
            number_of_codes_to_generate: values.number_of_codes_to_generate,
            navigate,
          }),
        )
      } else if (values.codeType == 'whitelabel-referral-code') {
        await dispatch(
          addWhitelabelReferralCode({
            business_client: values.business_client,
            contract_ref: values.contract_ref,
            prefix: values.prefix,
            expire_at: values.expire_at,
            useLimit: values.useLimit || 1,
            free_access_end_date: new Date(values.free_access_end_date).getTime(),
            navigate,
          }),
        )
      } else {
        await dispatch(
          addReferralCode({
            expire_at: values.expire_at,
            business_client: values.business_client,
            for_business_client: values.for_business_client,
            prefix: values.prefix,
            number_of_codes_to_generate: values.number_of_codes_to_generate,
            useLimit: values.useLimit || 1,
            free_duration: values.free_duration
              ? parseInt(values.free_duration)
              : undefined,
            navigate,
          }),
        )
      }
    },
    validateOnChange: false, // Disable validation on change
    validateOnBlur: false, // Disable validation on blur
  })

  const { values, setFieldValue, handleBlur, handleSubmit, setFieldTouched } =
    formik

  const handleGetBusinesses = () => {
    dispatch(getBusinesses({ type: '' }))
  }

  useEffect(() => {
    if (formik.values.codeType) {
      formik.resetForm({
        values: { ...initialValues, codeType: formik.values.codeType },
      })
      setOpenLicenceCount(0) // NEW — don't carry a stale contract count across codeType switches
    }
  }, [formik.values.codeType])

  useEffect(() => {
    if (user && user.business) {
      if (user?.business?.name) {
        const isAdmin = user.roles.includes('master')
        let businessNames: string[]

        switch (user.business.name) {
          case 'sopher':
            businessNames = isAdmin
              ? ['sopher', 'SOPHER_ACCOUNTING']
              : ['sopher']
            break

          case 'sopher-test': {
            // console.log('sopher-test business name from get clients',user.email, user.user_name ,user.business.name)
            businessNames = isAdmin
              ? ['sopher-test', 'SOPHER_ACCOUNTING_TEST']
              : ['sopher-test']
            break
          }

          default: {
            //  console.log('default business name from get clients',user.email, user.user_name ,user.business.name)
            businessNames = [user.business.name]
            break
          }
        }
        dispatch(getContractsByBusinesses({ business_names: businessNames }))
      }
    }

    handleGetBusinesses()
  }, [])

  useEffect(() => {
    // console.log(' fetch contracts for business', formik.values.business_client)
    if (
      formik.values.business_client &&
      typeof formik.values.business_client == 'string' &&
      formik.values.business_client.length > 0 &&
      contracts &&
      contracts.length > 0
    ) {
      // setFilteredContracts(contracts.filter((item: ContractType )=> item.business_client == formik.values.business_client));
      setFilteredContracts(
        contracts.filter(
          (item: ContractType) =>
            item.business_client == formik.values.business_client &&
            item.useLimit - item.licence_count > 0 &&
            item.expire_at &&
            new Date(item.expire_at) > new Date(),
        ),
      )
    }
  }, [formik.values.business_client])

  // Wrapper function to handle form submission from button click
  const handleFormSubmit = async (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault()
    await formik.submitForm()

    /* const isValid = await formik.validateForm(); // Validate the form
    formik.setTouched();
    // Check if there are errors in the form
    if (Object.keys(isValid).length === 0) {
      try {
        await formik.submitForm(); // Call the Formik's submit function, which should handle your API call
        // If successful, reset the form
        formik.resetForm();
      } catch (e) {
        console.log('Error while submitting the form:', e);
        // Handle error, e.g., show an error message to the user
      }
    } else {
      console.log('Form has errors:', isValid);
      // You may want to display these errors to the user
    }*/
  }

  const handleContractRefChange = async (
    e: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const { name, value } = e.target
    await setFieldValue(name, value)
    await setFieldTouched(name, true)
    const valid = await validationSchema.validateAt(name, { [name]: value })
    if (valid) {
      formik.setFieldError(name, undefined) // Clear the error if validation passes
      const selectedContract = filteredContracts?.filter(
        (item) => item.id == e.target.value,
      )
      if (selectedContract && selectedContract?.length > 0) {
        setOpenLicenceCount(
          selectedContract[0].useLimit - selectedContract[0].licence_count,
        )
        setFieldValue('expire_at', selectedContract[0].expire_at)
        setFieldValue('business_client', selectedContract[0].business_client)
        setFieldValue(
          'contract_left_licences',
          selectedContract[0].useLimit - selectedContract[0].licence_count,
        )
        const validCount = await validationSchema.validateAt(
          'contract_left_licences',
          {
            ['contract_left_licences']:
              selectedContract[0].useLimit -
              selectedContract[0].licence_count,
          },
        )
        if (validCount) {
          formik.setFieldError('contract_left_licences', undefined) // Clear the error if validation passes
        } else {
          formik.setFieldError(
            'contract_left_licences',
            'All licences in the selected contract have been used. Please choose another contract.',
          )
        }

        try {
          await validationSchema.validateAt('expire_at', {
            expire_at: selectedContract[0].expire_at
              ? new Date(selectedContract[0].expire_at)
              : '',
            codeType: ['licence-code'], // include this as well
          })
          formik.setFieldError('expire_at', undefined)
        } catch (error) {
          if (error instanceof Error) {
            // Handle the error if validation fails
            console.error('Validation error:', error.message)
          }
          formik.setFieldError(
            'expire_at',
            'The selected contract has expired. Please choose another contract.',
          )
        }
      }
    }
  }

  // NEW — contract select handler for the whitelabel-referral-code flow.
  // Computes remaining licences (to cap useLimit) and the free-access end
  // date (mirrors the contract's expire_at, no manual free_duration input).
  const handleWhitelabelContractRefChange = async (
    e: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const { name, value } = e.target
    await setFieldValue(name, value)
    await setFieldTouched(name, true)

    const selectedContract = filteredContracts?.find(
      (item) => item.id == value,
    )

    if (selectedContract) {
      const remaining =
        selectedContract.useLimit - selectedContract.licence_count
      setOpenLicenceCount(remaining)
      setFieldValue('contract_left_licences', remaining)
      setFieldValue('free_access_end_date', selectedContract.expire_at)

      if (values.useLimit > remaining) {
        setFieldValue('useLimit', remaining > 0 ? remaining : 1)
      }

      formik.setFieldError('contract_ref', undefined)
    } else {
      setFieldValue('contract_left_licences', 0)
      setFieldValue('free_access_end_date', '')
    }
  }

  // NEW — clamps useLimit to the remaining contract capacity as the admin types.
  // `max` on the <input> is a UI hint only; browsers don't strictly enforce it.
  const handleWhitelabelUseLimitChange = async (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const numeric = Number(e.target.value)
    const max = values.contract_left_licences || 1
    const clamped = numeric > max ? max : numeric
    await setFieldValue('useLimit', clamped)
    await setFieldTouched('useLimit', true)
  }

  const handleSelectFieldChange1 = async (
    e:
      | React.ChangeEvent<HTMLSelectElement>
      | React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { name, value } = e.target

    if (name == 'business_client') {
      await setFieldValue('contract_ref', '')
      await setFieldValue('free_access_end_date', '') // NEW
      setOpenLicenceCount(0)
      setFieldValue('contract_left_licences', 0)
    }
    await setFieldValue(name, value)
    await setFieldTouched(name, true)
    if (name == 'role_type' && value == 'client') {
      await setFieldValue('roles', [])
    }

    if (name == 'codeType' && value == 'referral-code') {
      setFieldValue(
        'business_client',
        businesses?.find((item) => item.name == 'elisyan')?.id || '',
      )
    }

    const valid = await formik.validateForm()
    if (valid) {
      // console.log('field validated', name, value)
    } else {
      // console.log('field not validated', name, formik.errors)
    }
  }

  const handleSelectFieldChange2 = async (e: {
    name: string
    value: string | number | Option[]
  }) => {
    const { name, value } = e
    await setFieldValue(name, value)
    await setFieldTouched(name, true)
    const valid = await formik.validateForm()
    if (valid) {
      // console.log('field validated', name, value)
    } else {
      // console.log('field not validated', name, formik.errors)
    }
  }

  console.log('formik errors', formik.errors)
  useEffect(() => {
    // Log the form errors whenever they change
    console.log(
      'Current form errors:',
      formik.errors,
      formik.values,
      formik.dirty,
      formik.isValid,
    )
  }, [formik.errors, formik.values])

  // NEW — derived flag, kept in case other UI in this component wants it later
  const selectedReferralBusiness = businesses?.find(
    (item) => item.id === values.business_client,
  )

  return (
    <div className={classes?.container}>
      <div className={classes?.notificationForm}>
        <h1 className={classes?.title}>
          {t[textTheme].referralCodeScreen.form.title}
        </h1>
        <hr className={classes?.divider} />

        <form onSubmit={handleSubmit} className={classes?.notificationForm}>
          <CustomSelect
            name="codeType"
            value={values.codeType}
            options={[
              'licence-code',
              'referral-code',
              'invite-code',
              'whitelabel-referral-code',
            ]}
            onChange={(e) => handleSelectFieldChange1(e)}
            onBlure={handleBlur}
            placeholder="Select Code Type"
            label="Code Type"
          />

          {/* {values.codeType === 'invite-code' && (
            <SearchableSelect
              options={emailList}
              value={values.email}
              onChange={(value: string) => setFieldValue('email', value)}
              placeholder="Search for an email..."
            />
          )} */}

          {values.codeType === 'licence-code' && (
            <>
              <CustomSelect
                label="Business Client"
                name="business_client"
                value={values.business_client}
                options={
                  businesses
                    ? businesses.map((item) => ({
                        name: item.name,
                        id: item.id,
                      }))
                    : []
                }
                onChange={async (e) => await handleSelectFieldChange1(e)}
                placeholder="Select Business Client"
                onBlure={handleBlur}
                error={
                  formik.errors.business_client &&
                  formik.touched.business_client
                    ? formik.errors.business_client
                    : ''
                }
              />

              {values.business_client && (
                <>
                  <CustomSelect
                    label="Contract Reference"
                    name="contract_ref"
                    value={values.contract_ref}
                    options={
                      filteredContracts
                        ? filteredContracts
                            .filter((item) => item.contract_ref && item.id) // Ensures both are defined
                            .map((item) => ({
                              name: item.contract_ref as string,
                              id: item.id as string,
                            })) // Explicitly cast to string
                        : []
                    }
                    onChange={async (e) => await handleContractRefChange(e)}
                    onBlure={handleBlur}
                    placeholder="Select Contract Referrence"
                    error={
                      formik.errors.contract_ref &&
                      formik.touched.contract_ref
                        ? formik.errors.contract_ref
                        : ''
                    }
                  />
                  {values.contract_ref && (
                    <>
                      {' '}
                      <CustomInput
                        label={`Remaining Licences in the selected contract`}
                        name="contract_left_licences"
                        type="number"
                        value={openLicenceCount}
                        onChange={async (e) =>
                          await handleSelectFieldChange1(e)
                        }
                        disabled={true}
                      />
                      <CustomInput
                        label={
                          t[textTheme].generateLicencesScreen.form
                            .subscriptionExpiryInput.label
                        }
                        name="expire_at"
                        type="text"
                        value={values.expire_at}
                        onChange={() => {
                          return
                        }}
                        disabled
                        error={
                          formik.errors.expire_at
                            ? formik.errors.expire_at
                            : ''
                        }
                      />
                      <CustomSelect
                        label="Role Type"
                        name="role_type"
                        value={values.role_type}
                        options={[
                          { name: 'Client', id: 'client' },
                          { name: 'Advisor', id: 'advisor' },
                        ]}
                        onChange={async (e) =>
                          await handleSelectFieldChange1(e)
                        }
                        placeholder="Select Business Client"
                        onBlure={handleBlur}
                        error={
                          formik.errors.role_type && formik.touched.role_type
                            ? formik.errors.role_type
                            : ''
                        }
                      />
                      {values.role_type == 'advisor' && (
                        <CustomMultiSelect
                          name="roles"
                          value={values.roles}
                          onChange={(value) =>
                            handleSelectFieldChange2({
                              name: 'roles',
                              value: value,
                            })
                          }
                          options={roleList}
                          label="Roles To Assign"
                          error={
                            Array.isArray(formik.errors.roles)
                              ? formik.errors.roles.join(', ') // Combine all error messages into a single string
                              : formik.errors.roles || ''
                          }
                        />
                      )}
                      <CustomInput
                        label="Number of Licences to generate"
                        name="number_of_codes_to_generate"
                        type="number"
                        min={1}
                        max={values.contract_left_licences}
                        value={values.number_of_codes_to_generate}
                        onChange={async (e) =>
                          await handleSelectFieldChange1(e)
                        }
                        onBlure={handleBlur}
                        placeholder="Number of licences to generate"
                        error={
                          formik.errors.number_of_codes_to_generate &&
                          formik.touched.number_of_codes_to_generate
                            ? formik.errors.number_of_codes_to_generate
                            : ''
                        }
                      />
                    </>
                  )}
                </>
              )}
            </>
          )}

          {values.codeType === 'referral-code' && (
            <>
              <CustomSelect
                name="business_client"
                value={values.business_client}
                options={
                  businesses
                    ? businesses
                        .filter((item) => item.type !== 'distributer')
                        .map((item) => ({
                          name: item.name,
                          id: item.id,
                        }))
                    : []
                }
                onChange={(e) => {
                  handleSelectFieldChange1(e)

                  const selectedBusiness = businesses?.find(
                    (item) => item.id === e.target.value,
                  )

                  if (
                    selectedBusiness &&
                    selectedBusiness.name !== 'elisyan'
                  ) {
                    formik.setFieldValue(
                      'for_business_client',
                      selectedBusiness.name,
                    )
                  } else {
                    formik.setFieldValue('for_business_client', '')
                  }
                }}
                placeholder="Select Business Client Owner Of This Code"
                label="Business Client"
                disabled={false}
                error={
                  formik.errors.business_client &&
                  formik.touched.business_client
                    ? formik.errors.business_client
                    : ''
                }
              />
              <CustomSelect
                name="for_business_client"
                value={values.for_business_client}
                options={
                  businesses
                    ? businesses.map((item) => ({
                        name: item.name,
                        id: item.name,
                      }))
                    : []
                }
                onChange={(e) => handleSelectFieldChange1(e)}
                placeholder="Select Business Client That Will Share This Code"
                label="Business Client That will share the code"
                disabled={
                  businesses?.find((item) => item.id === values.business_client)
                    ?.name !== 'elisyan' && !!values.business_client
                }
                error={
                  formik.errors.for_business_client &&
                  formik.touched.for_business_client
                    ? formik.errors.for_business_client
                    : ''
                }
              />
              <CustomInput
                label="Prefix"
                name="prefix"
                type="text"
                value={values.prefix}
                onChange={(e) => handleSelectFieldChange1(e)}
                placeholder="Enter a Prefix"
                error={
                  formik.errors.prefix && formik.touched.prefix
                    ? formik.errors.prefix
                    : ''
                }
              />
              <CustomInput
                label="Expiry Date"
                name="expire_at"
                type="date"
                value={values.expire_at}
                onChange={(e) => handleSelectFieldChange1(e)}
                placeholder="Select Expiry date"
                error={
                  formik.errors.expire_at && formik.touched.expire_at
                    ? formik.errors.expire_at
                    : ''
                }
              />
              <CustomSelect
                name="free_duration"
                label="Free Trial Duration"
                value={values.free_duration || ''}
                onChange={handleSelectFieldChange1}
                placeholder="-- Select Duration --"
                options={[
                  { id: '1', name: '1 Day' },
                  { id: '7', name: '1 Week' },
                  { id: '15', name: '2 Weeks' },
                  { id: '30', name: '1 Month' },
                  { id: '90', name: '3 Months' },
                  { id: '180', name: '6 Months' },
                  { id: '365', name: '1 Year' },
                ]}
              />
              {/*<CustomInput
                label='number of codes to generate'
                name="number_of_codes_to_generate"
                type="number"
                value={values.number_of_codes_to_generate}
                onChange={handleChange}
                placeholder="Number of referral codes to generate"
                error= {(formik.errors.number_of_codes_to_generate && formik.touched.number_of_codes_to_generate) ?
                  formik.errors.number_of_codes_to_generate : ''}
              />*/}
              <CustomInput
                label="Use Limit"
                name="useLimit"
                type="number"
                value={values.useLimit}
                onChange={(e) => handleSelectFieldChange1(e)}
                placeholder="Maximum number of users to use this access code"
                error={
                  formik.errors.useLimit && formik.touched.useLimit
                    ? formik.errors.useLimit
                    : ''
                }
              />
            </>
          )}

          {values.codeType === 'whitelabel-referral-code' && (
            <>
              <CustomSelect
                label="Business Client"
                name="business_client"
                value={values.business_client}
                options={
                  businesses
                    ? businesses
                        .filter(
                          (item) =>
                            item.type !== 'distributer' &&
                            item.name !== 'elisyan',
                        )
                        .map((item) => ({
                          name: item.name,
                          id: item.id,
                        }))
                    : []
                }
                onChange={(e) => handleSelectFieldChange1(e)}
                placeholder="Select Partner Business Client"
                onBlure={handleBlur}
                error={
                  formik.errors.business_client &&
                  formik.touched.business_client
                    ? formik.errors.business_client
                    : ''
                }
              />

              {values.business_client && (
                <>
                  <CustomSelect
                    label="Contract Reference"
                    name="contract_ref"
                    value={values.contract_ref}
                    options={
                      filteredContracts
                        ? filteredContracts
                            .filter((item) => item.contract_ref && item.id)
                            .map((item) => ({
                              name: item.contract_ref as string,
                              id: item.id as string,
                            }))
                        : []
                    }
                    onChange={handleWhitelabelContractRefChange}
                    onBlure={handleBlur}
                    placeholder="Select Contract Reference"
                    error={
                      formik.errors.contract_ref &&
                      formik.touched.contract_ref
                        ? formik.errors.contract_ref
                        : ''
                    }
                  />

                  {values.contract_ref && (
                    <>
                      <CustomInput
                        label="Remaining Licences in the selected contract"
                        name="contract_left_licences"
                        type="number"
                        value={openLicenceCount}
                        onChange={() => {
                          return
                        }}
                        disabled
                      />

                      <CustomInput
                        label="Prefix"
                        name="prefix"
                        type="text"
                        value={values.prefix}
                        onChange={(e) => handleSelectFieldChange1(e)}
                        placeholder="Enter a Prefix"
                        error={
                          formik.errors.prefix && formik.touched.prefix
                            ? formik.errors.prefix
                            : ''
                        }
                      />

                      <CustomInput
                        label="Expiry Date"
                        name="expire_at"
                        type="date"
                        value={values.expire_at}
                        onChange={(e) => handleSelectFieldChange1(e)}
                        placeholder="Select Expiry date"
                        error={
                          formik.errors.expire_at && formik.touched.expire_at
                            ? formik.errors.expire_at
                            : ''
                        }
                      />

                      <CustomInput
                        label="Free Access End Date"
                        name="free_access_end_date"
                        type="text"
                        value={
                          values.free_access_end_date
                            ? new Date(
                                values.free_access_end_date,
                              ).toLocaleString()
                            : ''
                        }
                        onChange={() => {
                          return
                        }}
                        disabled
                      />

                      <CustomInput
                        label={`Use Limit (max ${values.contract_left_licences} remaining on contract)`}
                        name="useLimit"
                        type="number"
                        min={1}
                        max={values.contract_left_licences}
                        value={values.useLimit}
                        onChange={handleWhitelabelUseLimitChange}
                        onBlure={handleBlur}
                        placeholder="Maximum number of users to use this code"
                        error={
                          formik.errors.useLimit && formik.touched.useLimit
                            ? formik.errors.useLimit
                            : ''
                        }
                      />
                    </>
                  )}
                </>
              )}
            </>
          )}

          {values.codeType && (
            <CustomButton
              title={
                values.codeType === 'licence-code'
                  ? 'Generate Licences'
                  : values.codeType === 'referral-code'
                  ? 'Generate Referral Code'
                  : values.codeType === 'whitelabel-referral-code'
                  ? 'Generate Whitelabel Referral Code'
                  : 'Generate Invite Code'
              }
              name="generateAccessCode"
              handleClick={handleFormSubmit}
              type="submit"
              loading={loading}
              disabled={!formik.isValid || loading || !formik.dirty}
            />
          )}
        </form>
      </div>
    </div>
  )
}

export default GenerateAccessCode
